[
  {
    "id": "vf-001",
    "title": "FIXER",
    "category": "Yapıştırma Harçları",
    "sku": "C1TE",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/fixer-cover.png"],
    "description": "Çimento esaslı, standart performanslı, kayma yapmayan, çalışma süresi uzatılmış yapıştırma harcı.",
    "specs": { "Ambalaj": "25 kg kraft torba", "Tüketim": "3-5 kg/m²", "Sınıf": "C1TE" },
    "features": ["Karo seramik, cam mozaik, doğal taş için", "İç mekan uygulamaları", "Kolay taraklanabilme"],
    "tags": ["yapıştırıcı", "seramik", "iç mekan"]
  },
  {
    "id": "vf-002",
    "title": "FLEXY",
    "category": "Yapıştırma Harçları",
    "sku": "C2T",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/flexy-cover.png"],
    "description": "Çimento esaslı, yüksek performanslı, kayma yapmayan yapıştırma harcı.",
    "specs": { "Ambalaj": "25 kg kraft torba", "Tüketim": "3-6 kg/m²", "Sınıf": "C2T" },
    "features": ["Porselen karo, granit ve doğal taş için", "İç ve dış mekanlara uygun", "Yüksek yapışma mukavemeti"],
    "tags": ["yapıştırıcı", "porselen", "granit", "doğal taş"]
  },
  {
    "id": "vf-003",
    "title": "FLEXY PRO",
    "category": "Yapıştırma Harçları",
    "sku": "C2TE",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/flexy-pro-cover.png"],
    "description": "Yüksek yapışma mukavemetine sahip, çalışma süresi uzatılmış porselen karo yapıştırıcısı.",
    "specs": { "Ambalaj": "25 kg kraft torba", "Tüketim": "3-6 kg/m²", "Sınıf": "C2TE" },
    "features": ["Büyük ebatlı porselenler için ideal", "Uzun çalışma süresi", "Güçlü yapışma performansı"],
    "tags": ["yapıştırıcı", "porselen", "büyük format"]
  },
  {
    "id": "vf-004",
    "title": "FLEXY PLUS",
    "category": "Yapıştırma Harçları",
    "sku": "C2TE S1",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/flexy-plus-cover.png"],
    "description": "Çimento esaslı, S1 sınıfı elastik yapıştırma harcı.",
    "specs": { "Ambalaj": "25 kg kraft torba", "Tüketim": "3-6 kg/m²", "Sınıf": "C2TE S1" },
    "features": ["Alttan ısıtmalı zeminler", "Yoğun trafikli alanlar", "Teras ve havuz uygulamaları"],
    "tags": ["elastik", "yerden ısıtma", "teras", "havuz"]
  },
  {
    "id": "vf-005",
    "title": "FLEX PORSELEN",
    "category": "Yapıştırma Harçları",
    "sku": "C2TE S1",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/flex-porselen-cover.png"],
    "description": "Yüksek performanslı, S1 sınıfı elastik porselen karo yapıştırıcısı.",
    "specs": { "Ambalaj": "25 kg kraft torba", "Tüketim": "3-6 kg/m²", "Sınıf": "C2TE S1" },
    "features": ["Dış cephe uygulamaları", "Zorlu yüzeyler üzerine seramik uygulaması", "Esnek yapısı ile gerilmeleri absorbe eder"],
    "tags": ["elastik", "dış cephe", "porselen"]
  },
  {
    "id": "vf-006",
    "title": "POOL",
    "category": "Yapıştırma Harçları",
    "sku": "C2TE S1",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/pool-cover.png"],
    "description": "Havuzlar için özel geliştirilmiş, su itici, elastik yapıştırma harcı.",
    "specs": { "Ambalaj": "25 kg kraft torba", "Tüketim": "3-6 kg/m²", "Sınıf": "C2TE S1" },
    "features": ["Su itici özellik", "Havuz, hamam ve su depoları için", "Cam mozaik yapıştırmaya uygun"],
    "tags": ["havuz", "hamam", "su itici", "cam mozaik"]
  },
  {
    "id": "vf-007",
    "title": "FLOOR PLUS",
    "category": "Yapıştırma Harçları",
    "sku": "C2FE S1",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/floor-plus-cover.png"],
    "description": "Zemin uygulamaları için akıcı kıvamlı, hızlı priz alan elastik harç.",
    "specs": { "Ambalaj": "20 kg kraft torba", "Tüketim": "3-6 kg/m²", "Sınıf": "C2FE S1" },
    "features": ["Büyük ebatlı zemin karoları", "Çift taraflı yapıştırma gerektirmez", "Hızlı uygulama imkanı"],
    "tags": ["zemin", "büyük format", "hızlı"]
  },
  {
    "id": "vf-008",
    "title": "FLEX RAPID",
    "category": "Yapıştırma Harçları",
    "sku": "C2FT",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/flex-rapid-cover.png"],
    "description": "Hızlı priz alan, yüksek performanslı yapıştırma harcı.",
    "specs": { "Ambalaj": "20 kg kraft torba", "Tüketim": "3-6 kg/m²", "Sınıf": "C2FT" },
    "features": ["6 saat sonra derz dolgusu yapılabilir", "1 günde kullanıma açılacak mekanlar için"],
    "tags": ["hızlı priz", "rapid"]
  },
  {
    "id": "vf-009",
    "title": "FLEX ULTRA",
    "category": "Yapıştırma Harçları",
    "sku": "C2TE S2",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/flex-ultra-cover.png"],
    "description": "S2 sınıfı çok elastik, yüksek performanslı yapıştırma harcı.",
    "specs": { "Ambalaj": "25 kg kraft torba", "Tüketim": "5-8 kg/m²", "Sınıf": "C2TE S2" },
    "features": ["Yüksek esneklik gerektiren yüzeyler", "Metal ve ahşap zeminler (astar ile)", "Yüksek çatlak köprüleme"],
    "tags": ["çok elastik", "metal", "ahşap", "çatlak köprüleme"]
  },
  {
    "id": "vf-010",
    "title": "HP",
    "category": "Yapıştırma Harçları",
    "sku": "D2T",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/hp-cover.png"],
    "description": "Kullanıma hazır pasta tipi karo yapıştırıcı.",
    "specs": { "Ambalaj": "5 kg / 15 kg plastik kova", "Tüketim": "3-4 kg/m²", "Sınıf": "D2T" },
    "features": ["Alçı plakalar ve boyalı yüzeyler", "Mutfak tezgah arası", "Pratik uygulama"],
    "tags": ["hazır pasta", "alçı", "mutfak"]
  },
  {
    "id": "vf-011",
    "title": "PurLaM",
    "category": "Yapıştırma Harçları",
    "sku": "PU",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/purlam-cover.png"],
    "description": "Poliüretan esaslı, 2 bileşenli, solventsiz çok amaçlı yapıştırıcı.",
    "specs": { "Ambalaj": "7 kg Set (6.25+0.75 kg)", "Tüketim": "1.25 kg/m²", "Tip": "Poliüretan 2K" },
    "features": ["Metal ve ahşap yüzeylerde seramik", "Gemi ve sanayi tesisleri", "Mükemmel elastikiyet"],
    "tags": ["poliüretan", "2K", "metal", "sanayi", "gemi"]
  },
  {
    "id": "vf-012",
    "title": "DERZ 1-6 mm",
    "category": "Derz Dolgu Malzemeleri",
    "sku": "CG1",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/derz-1-6-cover.png"],
    "description": "Standart performanslı, 1-6 mm arası dar derzler için çimento esaslı dolgu.",
    "specs": { "Ambalaj": "20 kg kraft torba", "Derz Genişliği": "1-6 mm", "Sınıf": "CG1" },
    "features": ["Pürüzsüz yüzey", "Aşınmaya dayanıklı", "İç mekanlar için"],
    "tags": ["derz", "dar derz", "iç mekan"]
  },
  {
    "id": "vf-013",
    "title": "FLEX DERZ 0-5 mm",
    "category": "Derz Dolgu Malzemeleri",
    "sku": "CG2 WA",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/flex-derz-0-5-cover.png"],
    "description": "Yüksek performanslı, silikon katkılı, su itici elastik derz dolgu.",
    "specs": { "Ambalaj": "20 kg / 5 kg", "Derz Genişliği": "0-5 mm", "Sınıf": "CG2 WA" },
    "features": ["Zor kirlenir, kolay temizlenir", "Su itici özellik", "Yerden ısıtmaya uygun"],
    "tags": ["derz", "elastik", "su itici", "silikon katkılı"]
  },
  {
    "id": "vf-014",
    "title": "FLEX DERZ 2-12 mm",
    "category": "Derz Dolgu Malzemeleri",
    "sku": "CG2 WA",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/flex-derz-2-12-cover.png"],
    "description": "Yüksek performanslı, geniş derz aralıkları için elastik dolgu.",
    "specs": { "Ambalaj": "20/10/5/1 kg seçenekleri", "Derz Genişliği": "2-12 mm", "Sınıf": "CG2 WA" },
    "features": ["Geniş derzler için", "Donmaya karşı dayanıklı", "Rengi tam gösteren pürüzsüz yapı"],
    "tags": ["derz", "geniş derz", "elastik"]
  },
  {
    "id": "vf-015",
    "title": "RUSTİK DERZ 3-20 mm",
    "category": "Derz Dolgu Malzemeleri",
    "sku": "CG2 WA",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/rustik-cover.png"],
    "description": "Rustik görünümlü, kalın dolgulu dekoratif derz dolgu.",
    "specs": { "Ambalaj": "20 kg kraft torba", "Derz Genişliği": "3-20 mm", "Sınıf": "CG2 WA" },
    "features": ["Dekoratif tuğla ve doğal taş için", "Dış mekan ve bahçe yolları", "Kalın dolgu yapısı"],
    "tags": ["rustik", "dekoratif", "doğal taş", "tuğla"]
  },
  {
    "id": "vf-016",
    "title": "POOL G 2-10 mm",
    "category": "Derz Dolgu Malzemeleri",
    "sku": "CG2 WA",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/pool-g-cover.png"],
    "description": "Havuzlar için özel geliştirilmiş, kimyasal dayanımlı derz dolgu.",
    "specs": { "Ambalaj": "15 kg plastik kova", "Derz Genişliği": "2-10 mm" },
    "features": ["Havuz ve su depoları", "Tuz ve sülfatlı suya dayanıklı", "Hızlı priz alma"],
    "tags": ["havuz", "kimyasal dayanım", "derz"]
  },
  {
    "id": "vf-017",
    "title": "EPOXY ULTRA",
    "category": "Derz Dolgu Malzemeleri",
    "sku": "RG",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/epoxy-ultra-cover.png"],
    "description": "Epoksi reçine esaslı, asit ve kimyasal dayanımlı derz dolgu.",
    "specs": { "Ambalaj": "5 kg plastik kova set", "Sınıf": "RG", "Tip": "Epoksi 2K" },
    "features": ["Gıda tesisleri ve hastaneler", "Antibakteriyal", "Aside tam dayanım"],
    "tags": ["epoksi", "antibakteriyal", "asit dayanımı", "hastane", "gıda tesisi"]
  },
  {
    "id": "vf-018",
    "title": "FILM",
    "category": "Astar ve Katkılar",
    "sku": "ASTAR",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/film-cover.png"],
    "description": "Sentetik reçine esaslı, emici yüzeyler için astar.",
    "specs": { "Ambalaj": "5 lt plastik bidon", "Tüketim": "0.1-0.2 lt/m²" },
    "features": ["Alçı ve şap yüzeylerin su emiciliğini dengeler", "Tozumayı engeller"],
    "tags": ["astar", "alçı", "şap", "su emicilik"]
  },
  {
    "id": "vf-019",
    "title": "ASTAR",
    "category": "Astar ve Katkılar",
    "sku": "ASTAR-G",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/astar-cover.png"],
    "description": "Genel amaçlı sentetik reçine esaslı astar.",
    "specs": { "Ambalaj": "5 lt plastik bidon", "Tüketim": "0.1-0.15 lt/m²" },
    "features": ["Boya öncesi uygulama", "Zayıf yüzeyleri güçlendirme"],
    "tags": ["astar", "genel amaçlı"]
  },
  {
    "id": "vf-020",
    "title": "FILM PLUS",
    "category": "Astar ve Katkılar",
    "sku": "ASTAR-FP",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/film-plus-cover.png"],
    "description": "Parlak yüzeyler için dolgulu astar.",
    "specs": { "Ambalaj": "3 kg / 1 kg kova", "Tüketim": "0.3-0.4 kg/m²" },
    "features": ["Seramik üzerine seramik uygulaması", "Mermer ve granit üstü astar"],
    "tags": ["astar", "seramik üzeri", "mermer", "granit"]
  },
  {
    "id": "vf-021",
    "title": "FILM PLUS BETON",
    "category": "Astar ve Katkılar",
    "sku": "ASTAR-FPB",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/film-plus-beton-cover.png"],
    "description": "Brüt beton yüzeyler için dolgulu astar.",
    "specs": { "Ambalaj": "12 kg kova" },
    "features": ["Alçı sıva öncesi brüt beton astarı", "Yapışma mukavemetini artırır"],
    "tags": ["astar", "beton", "brüt beton"]
  },
  {
    "id": "vf-022",
    "title": "HYDROSIL",
    "category": "Astar ve Katkılar",
    "sku": "HYDROSIL",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/hydrosil-cover.png"],
    "description": "Silikon esaslı şeffaf su itici emprenye astar.",
    "specs": { "Ambalaj": "5 lt plastik bidon" },
    "features": ["Tuğla ve doğal taşı korur", "Yüzeyi nefes alan yapıda bırakır"],
    "tags": ["su itici", "emprenye", "silikon", "doğal taş", "tuğla"]
  },
  {
    "id": "vf-023",
    "title": "NET",
    "category": "Yüzey Temizlik ve Bakım",
    "sku": "NET-T",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/net-cover.png"],
    "description": "Asidik, konsantre karo seramik temizleyicisi.",
    "specs": { "Ambalaj": "1 lt plastik bidon" },
    "features": ["Derz ve yapıştırıcı kalıntılarını temizler", "İnşaat sonrası temizlik"],
    "tags": ["temizlik", "asidik", "inşaat sonrası", "seramik"]
  },
  {
    "id": "vf-024",
    "title": "DERZ TEMİZLEYİCİ",
    "category": "Yüzey Temizlik ve Bakım",
    "sku": "DERZ-T",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/derz-temizleyici-cover.png"],
    "description": "Sprey formunda asidik derz temizleyicisi.",
    "specs": { "Ambalaj": "0.5 lt sprey" },
    "features": ["Zamanla sararan derzleri canlandırır", "Pratik banyo temizliği"],
    "tags": ["derz temizlik", "sprey", "banyo"]
  },
  {
    "id": "vf-025",
    "title": "PROOF S",
    "category": "Su Yalıtım Malzemeleri",
    "sku": "PROOF-S",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/proof-s-cover.png"],
    "description": "Yarı elastik, 2 bileşenli çimento esaslı su yalıtım malzemesi.",
    "specs": { "Ambalaj": "25 kg set (20 kg toz + 5 kg sıvı)", "Tip": "2K Çimento Esaslı" },
    "features": ["Banyo ve mutfak yalıtımı", "Dikey ve yatay kullanım"],
    "tags": ["su yalıtımı", "banyo", "mutfak", "2K"]
  },
  {
    "id": "vf-026",
    "title": "PROOF",
    "category": "Su Yalıtım Malzemeleri",
    "sku": "PROOF",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/proof-cover.png"],
    "description": "Elastik, 2 bileşenli su yalıtım malzemesi.",
    "specs": { "Ambalaj": "33 kg set (25 kg toz + 8 lt sıvı)", "Tip": "2K Elastik" },
    "features": ["Balkon ve teras uygulamaları", "İç ve dış mekan yalıtımı"],
    "tags": ["su yalıtımı", "elastik", "balkon", "teras"]
  },
  {
    "id": "vf-027",
    "title": "PROOF F",
    "category": "Su Yalıtım Malzemeleri",
    "sku": "PROOF-F",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/proof-f-cover.png"],
    "description": "Tam elastik, yüksek performanslı su yalıtım malzemesi.",
    "specs": { "Ambalaj": "30 kg set (20 kg toz + 10 lt sıvı)", "Tip": "2K Tam Elastik" },
    "features": ["Olimpik havuzlar", "Temel ve perde duvarlar", "Çatlak köprüleme"],
    "tags": ["su yalıtımı", "tam elastik", "havuz", "temel"]
  },
  {
    "id": "vf-028",
    "title": "PROOF UV",
    "category": "Su Yalıtım Malzemeleri",
    "sku": "PROOF-UV",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/proof-uv-cover.png"],
    "description": "UV dayanımı artırılmış elastik su yalıtım malzemesi.",
    "specs": { "Ambalaj": "33 kg set", "Tip": "UV Dayanımlı Elastik" },
    "features": ["Açık teraslar", "Güneş alan bölgeler için"],
    "tags": ["su yalıtımı", "UV dayanım", "teras", "dış mekan"]
  },
  {
    "id": "vf-029",
    "title": "PROOF CRYSTAL",
    "category": "Su Yalıtım Malzemeleri",
    "sku": "PROOF-C",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/proof-crystal-cover.png"],
    "description": "Kristalize, kapiler etkili su yalıtım malzemesi.",
    "specs": { "Ambalaj": "25 kg kraft torba", "Tip": "Kristalize" },
    "features": ["Negatif yönden su yalıtımı", "Bodrumlar ve asansör kuyuları"],
    "tags": ["su yalıtımı", "kristalize", "bodrum", "negatif yön"]
  },
  {
    "id": "vf-030",
    "title": "HYDROSTOP",
    "category": "Su Yalıtım Malzemeleri",
    "sku": "HYDROSTOP",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/hydrostop-cover.png"],
    "description": "Akrilik reçine esaslı, kullanıma hazır elastik yalıtım.",
    "specs": { "Ambalaj": "10/20 kg kova", "Tip": "Akrilik Tek Bileşen" },
    "features": ["Kullanıma hazır", "Boya yapılabilen yüzey"],
    "tags": ["su yalıtımı", "hazır", "akrilik", "boyanabilir"]
  },
  {
    "id": "vf-031",
    "title": "HYDROSTOP UV",
    "category": "Su Yalıtım Malzemeleri",
    "sku": "HYDROSTOP-UV",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/hydrostop-uv-cover.png"],
    "description": "Elastomerik reçine esaslı UV dayanımlı dış cephe yalıtımı.",
    "specs": { "Ambalaj": "20 kg kova", "Tip": "Elastomerik UV" },
    "features": ["Çatı ve dere olukları", "Mükemmel dış koşul dayanımı"],
    "tags": ["su yalıtımı", "UV", "çatı", "dış cephe"]
  },
  {
    "id": "vf-032",
    "title": "PAH BANDI",
    "category": "Su Yalıtım Malzemeleri",
    "sku": "PAH-B",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/pah-bandi-cover.png"],
    "description": "Köşe ve ek yerleri için elastik yalıtım bandı.",
    "specs": { "Ambalaj": "50 m rulo" },
    "features": ["Köşe birleşim noktaları", "Harekete maruz bölgeler"],
    "tags": ["su yalıtımı", "bant", "köşe", "ek yeri"]
  },
  {
    "id": "vf-033",
    "title": "S 10",
    "category": "Zemin Grubu",
    "sku": "S10",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/s10-cover.png"],
    "description": "3-10 mm arası kendinden yayılan tesviye şapı.",
    "specs": { "Ambalaj": "25 kg kraft torba", "Kalınlık": "3-10 mm" },
    "features": ["Laminat ve PVC öncesi düzgün zemin", "Tozuma yapmaz"],
    "tags": ["zemin şapı", "tesviye", "laminat", "PVC"]
  },
  {
    "id": "vf-034",
    "title": "S 30",
    "category": "Zemin Grubu",
    "sku": "S30",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/s30-cover.png"],
    "description": "4-30 mm arası kendinden yayılan tesviye şapı.",
    "specs": { "Ambalaj": "25 kg kraft torba", "Kalınlık": "4-30 mm" },
    "features": ["Yerden ısıtmalı zeminler", "Kalın dolgu imkanı"],
    "tags": ["zemin şapı", "tesviye", "yerden ısıtma"]
  },
  {
    "id": "vf-035",
    "title": "F 50",
    "category": "Zemin Grubu",
    "sku": "F50",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/f50-cover.png"],
    "description": "10-50 mm arası zemin düzeltme harcı.",
    "specs": { "Ambalaj": "25 kg kraft torba", "Kalınlık": "10-50 mm" },
    "features": ["Boşluk doldurma ve eğim verme", "Eski beton zeminlerin yenilenmesi"],
    "tags": ["zemin", "dolgu", "beton tamir"]
  },
  {
    "id": "vf-036",
    "title": "FLOOR QR",
    "category": "Zemin Grubu",
    "sku": "FLOOR-QR",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/floor-qr-cover.png"],
    "description": "Kuvars agregalı endüstriyel zemin sertleştirici.",
    "specs": { "Ambalaj": "25 kg kraft torba" },
    "features": ["Oto servisler ve depolar", "Aşınmaya dirençli yüzey"],
    "tags": ["zemin sertleştirici", "kuvars", "endüstriyel", "depo"]
  },
  {
    "id": "vf-037",
    "title": "PU SEALANT",
    "category": "Silikon ve Mastikler",
    "sku": "PU-S",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/pu-sealant-cover.png"],
    "description": "Poliüretan esaslı, çok amaçlı sızdırmazlık mastiği.",
    "specs": { "Ambalaj": "600 ml sosis", "Tip": "Poliüretan" },
    "features": ["Geniş genleşme derzleri", "Su geçirmez dolgu"],
    "tags": ["poliüretan", "mastik", "genleşme derzi"]
  },
  {
    "id": "vf-038",
    "title": "SM 610",
    "category": "Silikon ve Mastikler",
    "sku": "SM610",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/sm610-cover.png"],
    "description": "Genel amaçlı asetik silikon mastik.",
    "specs": { "Ambalaj": "280 ml kartuş", "Tip": "Asetik Silikon" },
    "features": ["Sıhhi tesisat ve cam uygulamaları", "Hijyenik"],
    "tags": ["silikon", "asetik", "cam", "sıhhi tesisat"]
  },
  {
    "id": "vf-039",
    "title": "SM 910",
    "category": "Silikon ve Mastikler",
    "sku": "SM910",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/sm910-cover.png"],
    "description": "Hijyenik asetik silikon (üst segment), küf önleyici formül.",
    "specs": { "Ambalaj": "310 ml kartuş", "Tip": "Asetik Silikon Premium" },
    "features": ["Küf tutmayan formül", "Banyo ve mutfak bitiş derzleri"],
    "tags": ["silikon", "küf önleyici", "banyo", "mutfak", "premium"]
  },
  {
    "id": "vf-040",
    "title": "RM FLAT",
    "category": "Tamir Harçları",
    "sku": "RM-FLAT",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/rm-flat-cover.png"],
    "description": "İnce taneli beton tamir ve yüzey düzleme harcı.",
    "specs": { "Ambalaj": "25 kg kraft torba" },
    "features": ["Sıva öncesi yüzey hazırlığı", "Beton çatlak tamiri"],
    "tags": ["tamir harcı", "beton tamir", "yüzey düzleme"]
  },
  {
    "id": "vf-041",
    "title": "RM 20",
    "category": "Tamir Harçları",
    "sku": "RM20",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/rm20-cover.png"],
    "description": "Kalın taneli, yüksek mukavemetli yapısal tamir harcı.",
    "specs": { "Ambalaj": "25 kg kraft torba" },
    "features": ["Kolon ve kiriş tamirleri", "Deniz yapıları ve köprüler"],
    "tags": ["yapısal tamir", "kolon", "köprü", "deniz yapısı"]
  },
  {
    "id": "vf-042",
    "title": "GROUT",
    "category": "Tamir Harçları",
    "sku": "GROUT",
    "images": ["https://www.vitrafix.com.tr/_userfiles/dosyalar/urunler/grout-cover.png"],
    "description": "Akışkan, rötresiz, yüksek mukavemetli montaj harcı.",
    "specs": { "Ambalaj": "25 kg kraft torba", "Tip": "Rötresiz Montaj" },
    "features": ["Makine ve vinç sabitlenmesi", "Prefabrik eleman montajı"],
    "tags": ["montaj harcı", "rötresiz", "makine sabitleme", "prefabrik"]
  }
]
